import { render, staticRenderFns } from "./FlashPick.vue?vue&type=template&id=13a47af6&scoped=true"
import script from "./FlashPick.vue?vue&type=script&lang=js"
export * from "./FlashPick.vue?vue&type=script&lang=js"
import style0 from "./FlashPick.vue?vue&type=style&index=0&id=13a47af6&prod&lang=css"
import style1 from "./FlashPick.vue?vue&type=style&index=1&id=13a47af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a47af6",
  null
  
)

export default component.exports